
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Link, redirect } from "@tanstack/react-router";
import { Button } from "~frontend/components/ui/button";
import { auth } from "~frontend/lib/auth";
import { trpc } from "~frontend/router";

export const Route = createFileRoute("/")({
  ssr: false,
  beforeLoad: async () => {
    const { data: session } = await auth.getSession();
    if (session?.user?.id) {
      throw redirect({
        to: "/dashboard",
      });
    }
  },
  component: Home,
});

function Home() {
  const { data, isLoading } = useQuery(trpc.hello.hello.queryOptions("hello"));
  const { data: session } = auth.useSession();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
      <div className="max-w-4xl mx-auto text-center space-y-8 p-8">
        <div className="space-y-4">
          <h1 className="text-5xl font-bold text-gray-900">
            KCC Platform
          </h1>
          <Button asChild>
            <Link to="/login">Login</Link>
          </Button>
        </div>

        {JSON.stringify(session)}


        {isLoading && (
          <div className="text-sm text-gray-500">
            Connecting to backend... {data}
          </div>
        )}
      </div>
    </div >
  );
}
